import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6cb130ca")

_pushScopeId("data-v-6cb130ca")
const _hoisted_1 = { class: "flex flex-row items-center gap-x-3 gap-y-2" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row gap-x-3"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Search, {
      onInput: _ctx.onSearch,
      onClear: _ctx.onClearSearch,
      value: _ctx.localSearch,
      placeholder: _ctx.$t('cargo.v2.filter.searchPlaceholder'),
      minChar: 0,
      timeout: 400,
      customMargin: "mr-0"
    }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
    (_ctx.isSuccessBookingTab)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modaOptions, (moda) => {
            return (_openBlock(), _createBlock("button", {
              key: moda.value,
              type: "button",
              class: [
          'rounded-lg py-2.5 px-4 text-12px font-semibold whitespace-nowrap border',
          _ctx.isModaSelected(moda.value)
            ? 'bg-pink-lp-500 text-red-lp-100 border-red-lp-100'
            : 'bg-white text-gray-lp-300 border-gray-lp-1600'
        ],
              onClick: ($event: any) => (_ctx.onFilterModa(moda.value))
            }, _toDisplayString(moda.name) + " " + _toDisplayString(_ctx.modaCount(moda.value)), 11, ["onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AdvancedFilter, {
      modelValue: _ctx.advancedFilterData,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.advancedFilterData = $event)),
      isCityDestination: "",
      isAirport: "",
      isHub: "",
      customTitlePlaceholderCityDestination: 
        _ctx.$t('cargo.labels.destinationCity')
      ,
      customTitlePlaceholderAirportCode: 
        _ctx.$t('cargo.labels.destinationAirportCode')
      ,
      customTitlePlaceholderHubLocation: _ctx.$t('cargo.labels.hubLocation'),
      isScroll: false,
      isDisabled: false,
      onChange: _ctx.onChangeAdvancedFilter,
      onReset: _ctx.onResetAdvancedFilter,
      title: _ctx.$t('cargo.filters.filter')
    }, null, 8, ["modelValue", "customTitlePlaceholderCityDestination", "customTitlePlaceholderAirportCode", "customTitlePlaceholderHubLocation", "onChange", "onReset", "title"]),
    _createVNode(_component_time_range_picker, {
      startDate: _ctx.localStartDate,
      endDate: _ctx.localEndDate,
      onSelect: _ctx.setPeriode,
      default: "custom",
      placeholder: _ctx.$t('cargo.filters.selectDate'),
      customClass: "border border-gray-lp-400 rounded-lg",
      customBackground: "bg-white",
      customPaddingIcon: "px-3 py-2 border-none",
      customPaddingField: "p-2 border-l-0 border-none",
      customIcon: "calendar-outlined"
    }, null, 8, ["startDate", "endDate", "onSelect", "placeholder"]),
    _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
  ]))
})